document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
  var slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
  var thumbnails = Array.from(gallery.querySelectorAll('[data-gallery-thumbnail]'));
  var previous = gallery.querySelector('[data-gallery-previous]');
  var next = gallery.querySelector('[data-gallery-next]');
  var counter = gallery.querySelector('[data-gallery-current]');
  var stage = gallery.querySelector('.product-gallery-stage');
  var activeSlide = gallery.querySelector('[data-gallery-slide].is-active');
  var current = activeSlide ? slides.indexOf(activeSlide) : 0;
  var touchStartX = 0;

  function mediaIdForSlide(slide) {
    return slide ? String(slide.getAttribute('data-media-id') || '') : '';
  }

  function navigableSlideIndexes() {
    return slides.reduce(function (indexes, slide, index) {
      if (slide.getAttribute('data-gallery-navigation') === 'true') indexes.push(index);
      return indexes;
    }, []);
  }

  function updateCounter() {
    if (!counter) return;
    var navigable = navigableSlideIndexes();
    var position = navigable.indexOf(current);
    counter.parentElement.hidden = position < 0;
    if (position >= 0) counter.textContent = String(position + 1);
  }

  function showSlide(index) {
    if (!slides.length) return;
    current = (index + slides.length) % slides.length;
    var currentMediaId = mediaIdForSlide(slides[current]);

    slides.forEach(function (slide, slideIndex) {
      var active = slideIndex === current;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
    });

    thumbnails.forEach(function (thumbnail) {
      var active = String(thumbnail.getAttribute('data-gallery-thumbnail')) === currentMediaId;
      thumbnail.classList.toggle('is-active', active);
      thumbnail.setAttribute('aria-current', active ? 'true' : 'false');
    });

    updateCounter();
  }

  function showMedia(mediaId) {
    var index = slides.findIndex(function (slide) {
      return mediaIdForSlide(slide) === String(mediaId);
    });
    if (index >= 0) showSlide(index);
  }

  function moveWithinGallery(direction) {
    var navigable = navigableSlideIndexes();
    if (!navigable.length) return;
    var position = navigable.indexOf(current);
    var nextPosition;

    if (position < 0) {
      nextPosition = direction > 0 ? 0 : navigable.length - 1;
    } else {
      nextPosition = (position + direction + navigable.length) % navigable.length;
    }
    showSlide(navigable[nextPosition]);
  }

  gallery.addEventListener('product:show-media', function (event) {
    if (event.detail && event.detail.mediaId) showMedia(event.detail.mediaId);
  });

  if (previous) {
    previous.addEventListener('click', function () {
      moveWithinGallery(-1);
    });
  }

  if (next) {
    next.addEventListener('click', function () {
      moveWithinGallery(1);
    });
  }

  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener('click', function () {
      showMedia(thumbnail.getAttribute('data-gallery-thumbnail'));
    });
  });

  if (stage) {
    stage.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') moveWithinGallery(-1);
      if (event.key === 'ArrowRight') moveWithinGallery(1);
    });

    stage.addEventListener('touchstart', function (event) {
      touchStartX = event.changedTouches[0].clientX;
    }, { passive: true });

    stage.addEventListener('touchend', function (event) {
      var distance = event.changedTouches[0].clientX - touchStartX;
      if (Math.abs(distance) < 45) return;
      moveWithinGallery(distance > 0 ? -1 : 1);
    }, { passive: true });
  }

  showSlide(current);
});
